import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoSolapaVueloTams } from '@shared/enums/tipoSolapaVueloTams';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-vuelos-index',
  templateUrl: './vuelos-index.component.html',
  styleUrls: ['./vuelos-index.component.scss']
})
export class VuelosIndexComponent {

  TipoUsuario = TipoUsuario;
  TipoSolapaVueloTams = TipoSolapaVueloTams;

  constructor(public authService: AuthService) { }

}
